import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';
import type { Wishlist } from '@bulknutrients/bulk-shared-lib/interfaces/Wishlist';
import { log } from '@lib/logs';
import useSWR from 'swr';

export function useWishlist(): {
  data: Wishlist | null;
  isLoading: boolean;
  error: unknown;
} {
  const apiUrl = new URL('/api/wishlist', 'https://a');

  const fetcher = async () => {
    const response = await fetch(apiUrl.pathname + apiUrl.search);
    const res = await response.json();

    if (!response.ok) {
      // Don't throw an error for 4xx responses, just return null
      if (/^4\d{2}$/.test(response.status.toString())) {
        return null;
      }

      const error = new Error('Unable to fetch wishlist');
      (error as Error & { status?: number }).status = response.status;
      throw error;
    }

    if (res.data) {
      return res.data;
    }

    return null;
  };

  // Get wishlist
  const { data, error, isLoading } = useSWR<Wishlist | null>(
    SWR_KEYS.wishlist,
    fetcher,
    {
      dedupingInterval: 500,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      onError: (error) => {
        log({ error, location: 'useWishlist' });
      },
    }
  );

  return { data: data ?? null, isLoading, error };
}
